import React, {Component} from 'react';
import {connect} from 'react-redux';
import queryString from 'query-string';
import MessageBox from '../../../Common/MessageBox';
import Captcha from '../../../Common/Captcha';
import {fetchIdentificationWithRequestTokenOrRedirectOnFail} from '../../../../actions/identification.actions';
import {putUserStateToWithdrawn} from '../../../../actions/user.actions';
import {
  Button,
  ButtonGroup,
  PageContainer,
  PageDescription,
  PageSubTitle,
  PageTitle,
  Table,
} from '../../../Common/PageComponents';
import {Link} from 'react-router-dom';

class Withdrawal extends Component {
  componentDidMount() {
    let requestParams = queryString.parse(window.location.search);
    this.props.dispatch(
      fetchIdentificationWithRequestTokenOrRedirectOnFail(
        requestParams.identityToken,
        '/my-pc-bang/management/withdrawal/identification',
        this.props.history,
        ''
      )
    );
  }

  _preventNonNumericValue(e) {
    if (e.charCode < 48 || e.charCode > 57) {
      e.preventDefault();
    }
  }

  _prepareWithdrawal(e) {
    e.preventDefault();

    if (!this.form.agreement.checked) {
      alert('회원탈퇴 안내를 읽고 동의해주세요.');
      this.form.agreement.focus();
      return;
    }

    if (!this.form.ownerName.value) {
      alert('대표자 이름을 입력해주세요.');
      this.form.ownerName.focus();
      return;
    }

    if (!this._isValidBusinessLicenseNumber()) {
      this.form.businessLicenseNumber01.focus();
      return;
    }

    if (!this.form.userName.value) {
      alert('아이디를 입력해주세요.');
      this.form.userName.focus();
      return;
    }

    if (!this.form.password.value) {
      alert('비밀번호를 입력해주세요.');
      this.form.password.focus();
      return;
    }

    this.captchaRef.execute();
  }

  _withdraw(captchaToken) {
    if (captchaToken === undefined || captchaToken === '') {
      window.alert('Captcha token에 문제가 있습니다. 다시 진행해 주세요.');
      return;
    }

    let businessLicenseNumber = null;
    if (!this.form.businessLicenseNumberNotRegistered.checked) {
      businessLicenseNumber = `${this.form.businessLicenseNumber01.value}-${this.form.businessLicenseNumber02.value}-${this.form.businessLicenseNumber03.value}`;
    }

    this.props.dispatch(
      putUserStateToWithdrawn(
        this.form.ownerName.value,
        businessLicenseNumber,
        this.form.userName.value,
        this.form.password.value,
        captchaToken,
        this.captchaRef,
        this.props.history
      )
    );
  }

  _isValidBusinessLicenseNumber() {
    if (this.form.businessLicenseNumberNotRegistered.checked) {
      return true;
    }

    let businessLicenseNumber = `${this.form.businessLicenseNumber01.value}-${this.form.businessLicenseNumber02.value}-${this.form.businessLicenseNumber03.value}`;

    if (businessLicenseNumber === '--') {
      alert('사업자 등록번호를 입력해주세요.');
      return false;
    }

    if (!businessLicenseNumber.match(/^[0-9]{3}-[0-9]{2}-[0-9]{5}$/)) {
      alert('올바른 사업자 등록번호 양식이 아닙니다.');
      return false;
    }

    return true;
  }

  _onBusinessLicenseNumberNotRegisteredClicked() {
    if (this.form.businessLicenseNumberNotRegistered.checked) {
      this.form.businessLicenseNumber01.value = '';
      this.form.businessLicenseNumber01.disabled = true;
      this.form.businessLicenseNumber02.value = '';
      this.form.businessLicenseNumber02.disabled = true;
      this.form.businessLicenseNumber03.value = '';
      this.form.businessLicenseNumber03.disabled = true;
      return;
    }

    this.form.businessLicenseNumber01.disabled = false;
    this.form.businessLicenseNumber02.disabled = false;
    this.form.businessLicenseNumber03.disabled = false;
  }

  render() {
    return (
      <PageContainer>
        <PageTitle title="회원탈퇴" data-qa="usagePageTitle" />
        <PageDescription>
          라이엇 게임즈 프리미엄 PC방 회원 탈퇴를 위해서는 아래 회원탈퇴 안내를 반드시 읽고 동의여부를 확인해 주셔야
          합니다.
        </PageDescription>
        <PageSubTitle title={'회원탈퇴 안내'} />
        <form ref={form => (this.form = form)} autoComplete="off" style={{marginTop: '40px'}}>
          <PageDescription>
            회원탈퇴 즉시 라이엇 게임즈 프리미엄 PC방 사이트 이용이 불가능합니다. 다만, 당사는 실수로 또는 기타 본인의
            의사와 인식 없이 회원탈퇴를 한 경우를 고려하여 이를 복구하기 위해 회원 탈퇴한 날로부터 30일 동안 개인 정보를
            보관하되, 회원 탈퇴 30일 경과 후에는 서비스 내 모든 정보가 삭제되기 때문에 이후 복구가 불가능합니다.
          </PageDescription>
          <div>
            <label>
              <input type="checkbox" name="agreement" />
              &nbsp;모든 내용을 이해했으며, 동의합니다.
            </label>
          </div>
          <PageSubTitle title={'회원 탈퇴신청'} />
          <Table theme={'form'}>
            <colgroup>
              <col width={160} />
              <col width="*" />
            </colgroup>
            <tbody>
              <tr>
                <th>대표자 이름</th>
                <td>
                  <input
                    type="text"
                    className="input_text"
                    name="ownerName"
                    id="ownerName"
                    maxLength={25}
                    style={{width: 180}}
                    autoComplete="off"
                  />
                </td>
              </tr>
              <tr>
                <th>사업자 등록번호</th>
                <td>
                  <input
                    type="text"
                    className="input_text"
                    name="businessLicenseNumber01"
                    id="businessLicenseNumber01"
                    maxLength={3}
                    style={{width: 80, marginRight: '5px'}}
                    onKeyPress={e => this._preventNonNumericValue(e)}
                    autoComplete="off"
                  />
                  -
                  <input
                    type="text"
                    className="input_text"
                    name="businessLicenseNumber02"
                    id="businessLicenseNumber02"
                    maxLength={2}
                    style={{width: 80, margin: '0 5px'}}
                    onKeyPress={e => this._preventNonNumericValue(e)}
                    autoComplete="off"
                  />
                  -
                  <input
                    type="text"
                    className="input_text"
                    name="businessLicenseNumber03"
                    id="businessLicenseNumber03"
                    maxLength={5}
                    style={{width: 80, marginLeft: '5px'}}
                    onKeyPress={e => this._preventNonNumericValue(e)}
                    autoComplete="off"
                  />
                  &nbsp;
                  <label>
                    <input
                      type="checkbox"
                      name="businessLicenseNumberNotRegistered"
                      onClick={() => this._onBusinessLicenseNumberNotRegisteredClicked()}
                    />{' '}
                    사업자 등록증 미등록
                  </label>
                </td>
              </tr>
              <tr>
                <th>아이디</th>
                <td>
                  <input
                    type="text"
                    className="input_text"
                    name="userName"
                    id="userName"
                    maxLength={16}
                    style={{imeMode: 'disabled', width: 180}}
                    autoComplete="off"
                  />
                </td>
              </tr>
              <tr>
                <th>비밀번호</th>
                <td>
                  <input
                    type="password"
                    className="input_text"
                    name="password"
                    id="password"
                    maxLength={16}
                    style={{width: 180}}
                    autoComplete="off"
                  />
                </td>
              </tr>
            </tbody>
          </Table>
        </form>
        <div style={{margin: '30px 0', textAlign: 'center'}}>
          라이엇 게임즈 프리미엄 PC방 사이트의 회원 탈퇴를 하시겠습니까?
        </div>
        <ButtonGroup>
          <Captcha
            ref={captchaRef => (this.captchaRef = captchaRef)}
            onVerify={captchaToken => this._withdraw(captchaToken)}
          />
          <Button onClick={e => this._prepareWithdrawal(e)}>탈퇴</Button>
          <Link to="/">
            <Button theme={'gray'}>취소</Button>
          </Link>
        </ButtonGroup>
        <br />
        <MessageBox>
          <strong>
            ‘사업자등록증 미발급’ 선택을 통해 회원가입 하신 분들은 <b>고객센터 (1688-1011)</b>으로 문의 주시기 바랍니다.
          </strong>
        </MessageBox>
      </PageContainer>
    );
  }
}

export default connect()(Withdrawal);
